<template>
  <div>
    <PageAllow controller="StockOrderAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 入库日期 / 时间类型 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出 -->
              <v-tooltip
                v-if="
                  $permission.permissionAllow('StockOrderAnalyze', 'export')
                "
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1"
                    @click.stop="exportExcel()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("StockDetails.export") }}
                  </v-btn>
                </template>
                <span>{{ $t("StockDetails.export") }}</span>
              </v-tooltip>
              <!-- 汇总导出 -->
              <v-tooltip
                v-if="
                  $permission.permissionAllow(
                    'StockOrderAnalyze',
                    'groupTypeExport'
                  )
                "
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    dark
                    color="print"
                    class="px-2 me-2 mb-1"
                    @click.stop="batchExportExcel()"
                  >
                    <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                    {{ $t("StockDetails.batchExport") }}
                  </v-btn>
                </template>
                <span>{{ $t("StockDetails.batchExport") }}</span>
              </v-tooltip>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 关键字 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    v-model="options.keyword"
                    @text="KeyWord = $event"
                    :label="$t('stockOrderAnalyze.materialKeyword')"
                  />
                </v-col>
                <!-- 商品分类 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterialCategory v-model="categorySelected" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="stock_order_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 商品编号 -->
            <template v-slot:item.material_code="{ item }">
              {{ $t("stockOrderAnalyze.code", [item.material_code]) }}
            </template>
            <template v-slot:item.standard_name="{ item }">
              <span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
                class="text-no-wrap"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else class="text-no-wrap">
                {{ item.standard_name }}
              </span>
            </template>
            <!-- 入库量格式化 -->
            <template v-slot:item.stockOrderIn="{ item }">
              {{ item.stockOrderIn ? item.stockOrderIn : 0 }}
            </template>
            <!-- 入库合计 -->
            <template v-slot:item.stockOrderInPrice="{ item }">
              {{ $t("Global.money") }}{{ item.stockOrderInPrice | formatMoney }}
            </template>
            <!-- 出库量 -->
            <template v-slot:item.stockOrderOut="{ item }">
              {{ item.stockOrderOut ? item.stockOrderOut : 0 }}
            </template>
            <!-- 出库合计 -->
            <template v-slot:item.stockOrderOutPrice="{ item }">
              {{ $t("Global.money")
              }}{{ item.stockOrderOutPrice | formatMoney }}
            </template>
            <!-- 出入库明细 -->
            <template v-slot:item.actions="{ item, index }">
              <span :v-resize="!index ? $stickTableResizer() : null"> </span>
              <v-tooltip
                v-if="
                  $permission.permissionAllow('StockOrderAnalyze', 'details')
                "
                top
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    v-bind="attrs"
                    v-on="on"
                    :dark="detailMode"
                    color="info"
                    class="px-2 me-2"
                    :href="'/#/stock-order-analyze/' + item.material_id"
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("stockOrderAnalyze.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("stockOrderAnalyze.detail")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import stockOrderAnalyze from "@/api/stock_order_analyze";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  keyword: "",
  category_code: "",
};

export default {
  name: "stockDetails",
  data: () => ({
    stock_order_analyze: [],
    stocksSelected: null,
    orderCodeKeyword: "",
    materialCategoriesSelected: [],
    materialSelected: null,
    stockDistrictSelected: null,
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    categorySelected: null,
  }),
  components: {
    Breadcrumbs,
    SearcherKeyword,
    SearcherMaterialCategory,
    PageAllow,
    SearcherDatetimeRangeWithRadio,
  },
  props: {
    detailMode: Boolean,
  },
  computed: {
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("stockOrderAnalyze.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("stockOrderAnalyze.Fields.actual_time"),
      },
    ],
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        href: "/current-stocks",
      },
      {
        text: i18n.t("Nav.stockOrderAnalyze"),
        disabled: true,
        href: "/stock-order-analyze",
      },
    ],
    headers: () => [
      {
        text: i18n.t("stockOrderAnalyze.Fields.material_category"),
        align: "start",
        sortable: false,
        value: "category_name",
      },
      {
        text: i18n.t("stockOrderAnalyze.Fields.material_code"),
        align: "start",
        sortable: false,
        value: "material_code",
      },
      {
        text: i18n.t("stockOrderAnalyze.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "material_name",
      },
      {
        text: i18n.t("stockOrderAnalyze.Fields.standard"),
        align: "start",
        sortable: false,
        value: "standard_name",
      },
      {
        text: i18n.t("stockOrderAnalyze.Fields.unit"),
        align: "start",
        sortable: false,
        value: "unit",
      },
      // 入库量
      {
        text: i18n.t("stockOrderAnalyze.Fields.in_num"),
        align: "end",
        sortable: false,
        value: "stockOrderIn",
      },
      // 入库合计
      {
        text: i18n.t("stockOrderAnalyze.Fields.in_total"),
        align: "end",
        sortable: false,
        value: "stockOrderInPrice",
      },
      // 出库量
      {
        text: i18n.t("stockOrderAnalyze.Fields.out_num"),
        align: "end",
        sortable: false,
        value: "stockOrderOut",
      },
      // 出库合计
      {
        text: i18n.t("stockOrderAnalyze.Fields.out_total"),
        align: "end",
        sortable: false,
        value: "stockOrderOutPrice",
      },
      // 操作
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],
    ...mapState(["accountSettings", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils
      .loadOptions("stockIN-and-stockOUT", ["categorySelected"])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "categorySelected":
                this.categorySelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options, { keyword: this.KeyWord });
    },
    resetSearch() {
      this.categorySelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getStockDetailsFromAPI() {
      this.loading = true;
      this.id = this.$route.query.stock_id;
      stockOrderAnalyze.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_order_analyze = response.data.stock_order_analyze;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      stockOrderAnalyze.exports(this.options);
    },
    batchExportExcel() {
      stockOrderAnalyze.batchExports(this.options);
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getStockDetailsFromAPI();
        sessionStorage.setItem(
          "stockIN-and-stockOUT-options",
          JSON.stringify(this.options)
        );
      },
    },
    categorySelected: {
      handler() {
        this.options.category_code = this.categorySelected
          ? this.categorySelected.code
          : "";
        sessionStorage.setItem(
          "stockIN-and-stockOUT-categorySelected",
          JSON.stringify(this.categorySelected)
        );
      },
    },
  },
};
</script>